import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Paper,
  Container,
  Typography
} from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../../theme/theme'

import ErrorMessage from "@/components/ph/ErrorMessage";
import Button from "@/components/ph/Button";

import {
  trackEventErrorStep1View,
  trackEventErrorStep1Call,
  trackEventErrorStep1Close,
  trackEventErrorConfirmView,
  trackEventErrorConfirmCall,
  trackEventErrorConfirmClose
} from "../../utils/analytics";

const ErrorPage = ({
  errorCode,
  errorTitle = "Atención Personalizada",
  errorDescription = "Fallo en la validación"
}) => {
 
  const currentStep = useSelector((state) => state.quote.step);

  const trackViewBasedOnStep = async () => {
    if (currentStep === 1) {
      await trackEventErrorStep1View(errorTitle, errorCode, errorDescription);
    } else if (currentStep === 3 || currentStep === 4) {
      await trackEventErrorConfirmView();
    }
  };

  const trackCallBasedOnStep = async () => {
    if (currentStep === 1) {
      await trackEventErrorStep1Call(errorTitle, errorCode, errorDescription);
    } else if (currentStep === 3 || currentStep === 4) {
      await trackEventErrorConfirmCall();
    }
  };

  const trackCloseBasedOnStep = async () => {
    if (currentStep === 1) {
      await trackEventErrorStep1Close(errorTitle, errorCode, errorDescription);
    } else if (currentStep === 3 || currentStep === 4) {
      await trackEventErrorConfirmClose();
    }
  };

  const handleCall = () => {
    trackCallBasedOnStep().catch(e => console.warn(e));

    const phoneNumber = "5552291999";
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
   
    if (isMobile) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      window.location.href = `skype:${phoneNumber}?call`;
    }
  };

  const handleExit = async () => {
    try {
      await trackCloseBasedOnStep();
    } catch (error) {
      console.warn("Error enviando analítica de cierre:", error);
    } finally {
      window.location.reload();
    }
  };

  useEffect(() => {
    trackViewBasedOnStep().catch(e => console.warn(e));
  }, [currentStep]);

  return (
    <ThemeProvider theme={theme}>
      <Container
        maxWidth="md"
        disableGutters
        sx={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", px: 2 }}
      >
        <Paper elevation={0} sx={{ p: { xs: 2, md: 4 }, width: "100%", textAlign: "center", maxWidth: { md: 600 } }}>
          <Grid container direction="column" alignItems="center">
           
            <ErrorMessage type="error" />

            <Typography sx={{ fontSize: "1rem", fontWeight: 500, mb: 2, color: "text.primary" }}>
              TU SOLICITUD REQUIERE ATENCIÓN PERSONALIZADA
            </Typography>

            <Typography sx={{ fontSize: "1rem", fontWeight: 400, mb: 3, color: "text.primary", lineHeight: 1.6 }}>
              Uno de nuestros ejecutivos te contactará en breve. Si deseas contratar tu póliza hoy mismo, por favor comunicate al 55 5229 1999. (opción 5 y luego opción 2), o acude al área de Seguros en tu Palacio favorito.
            </Typography>

            <Typography sx={{ fontSize: "0.85rem", fontWeight: 400, mb: 3, color: "text.primary" }}>
              {errorCode}
            </Typography>

            <Button label="Llamar" onClick={handleCall} variant="black" />
            <Typography sx={{ mt: 1 }}>{""}</Typography>
            <Button label="Cerrar" onClick={handleExit} variant="white" />
           
          </Grid>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default ErrorPage;
